import axios from 'axios'
import endpoints from '@/api/endpoints'

export default {
  async getTimesheetCategories (divisionID) {
    return axios.get(endpoints.timesheetCategories + '?division=' + divisionID).then((response) => {
      return response.data
    })
  },
  async updateTimesheetCategory (obj) {
    return axios.patch(endpoints.timesheetCategories + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  async createTimesheetCategory (obj) {
    return axios.post(endpoints.timesheetCategories, obj).then((response) => {
      return response.data
    })
  },
  async getTimesheetEntries (from, to, id) {
    return axios.get(endpoints.timesheetEntries + '?date__gte=' + from + '&date__lte=' + to + '&employee=' + id).then((response) => {
      return response.data
    })
  },
  async getTimesheetEntry (id) {
    return axios.get(endpoints.timesheetEntries + id + '/').then((response) => {
      return response.data
    })
  },
  async updateTimesheetEntry (obj) {
    return axios.patch(endpoints.timesheetEntries + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  async createTimesheetEntry (obj) {
    return axios.post(endpoints.timesheetEntries, obj).then((response) => {
      return response.data
    })
  },
  async deleteTimesheetEntry (id) {
    return axios.delete(endpoints.timesheetEntries + id + '/').then((response) => {
      return response.data
    })
  },
  async getTimesheetWorkedOns (entryID) {
    return axios.get(endpoints.timesheetWorkedOn + '?entry=' + entryID).then((response) => {
      return response.data
    })
  },
  async getProjectWorkedOns (projectID) {
    return axios.get(endpoints.timesheetWorkedOn + '?project=' + projectID).then((response) => {
      return response.data
    })
  },
  async getTimesheetWorkedOn (id) {
    return axios.get(endpoints.timesheetWorkedOn + id + '/').then((response) => {
      return response.data
    })
  },
  async deleteTimesheetWorkedOn (id) {
    return axios.delete(endpoints.timesheetWorkedOn + id + '/').then((response) => {
      return response.data
    })
  },
  async updateTimesheetWorkedOn (obj) {
    return axios.patch(endpoints.timesheetWorkedOn + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  async createTimesheetWorkedOn (obj) {
    return axios.post(endpoints.timesheetWorkedOn, obj).then((response) => {
      return response.data
    })
  },
  async getDivisionTimesheetDetails (divID) {
    // returns all project details filtered by division.
    return axios.get(endpoints.timesheetDetails + '?division=' + divID).then((response) => {
      return response.data
    })
  },
  async createTimesheetDetail (obj) {
    return axios.post(endpoints.timesheetDetails, obj).then((response) => {
      return response.data
    })
  },
  async updateTimesheetDetail (obj) {
    return axios.patch(endpoints.timesheetDetails + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
}